export enum CATEGORY_FIELDS {
    NAME = 'name',
    SHOW_MENU = 'show_menu',
    PARENT = 'parent',
    ALIAS = 'alias',
}
